import { ChatsStates } from "@/store/chats/types";

export const convertChatStateToArray = (chatsState: ChatsStates) => {
  return Object.values(chatsState);
};
